import Nav from '../../Global/Nav.vue'
export default {
  name: 'Schedule',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'todo_list',
      uploadApi: this.$axios.defaults.baseURL + 'files/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      colors: [
        { color: '#1989fa', percentage: 10 },
        { color: '#19bafa', percentage: 20 },
        { color: '#19eefa', percentage: 30 },
        { color: '#19fabe', percentage: 40 },
        { color: '#19fa7f', percentage: 50 },
        { color: '#25fa19', percentage: 60 },
        { color: '#97fa19', percentage: 70 },
        { color: '#8619fa', percentage: 80 },
        { color: '#fa7819', percentage: 90 },
        { color: '#fa1919', percentage: 100 }
      ],
      users: [],
      todoListKeywords: '',
      todoListLoading: false,
      todoList: [],
      todoListTotal: 0,
      todoListSize: 10,
      editTodoForm: {},
      editTodoVisible: false,
      completeTodoVisible: false,
      completeTodoLoading: false,
      completeTodoForm: {
        id: '',
        master_id: '',
        fileList: []
      },

      scheduleListKeywords: '',
      scheduleListLoading: false,
      scheduleList: [],
      scheduleListTotal: 0,
      scheduleListSize: 10,
      createScheduleVisible: false,
      createScheduleLoading: false,
      scheduleForm: {
        type: '1',
        title: '',
        desc: '',
        implementers: [],
        fileList: []
      },
      scheduleRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      steps: [{}],
      editScheduleVisible: false,
      editScheduleLoading: false,
      editScheduleLoadingText: '正在保存, 请稍候',
      editScheduleForm: {
        fileList: []
      },
      editScheduleRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      editSteps: [],
      viewOnly: false,
      timelineReverse: false,
      timelineTitle: '',
      timelineVisible: false,
      timelineLoading: false,
      timelineData: []
    }
  },
  mounted() {
    this.queryTodoList();
    this.queryScheduleList();
    // this.intervals = setInterval(() => {
    //   if (this.activeName === 'schedule_list') {
    //     this.queryScheduleList(false, true);
    //   }
    // }, 10000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'todo_list':
          this.queryTodoList();
          break;
        case 'schedule_list':
          this.queryScheduleList();
          break;
      }
    },
    queryTodoList(search = false, iv = false) {
      if (iv === false) {
        this.todoListLoading = true;
      }
      let todoListpage = search === true ? 1 : this.todoListpage;
      this.$axios.get(`schedule/list`, {
        params: {
          keywords: this.todoListKeywords,
          size: this.todoListSize,
          page: todoListpage,
          type: 'TODO'
        }
      }).then((response) => {
        this.todoListLoading = false;
        if (response.data.code === 200) {
          this.todoList = response.data.data.data
          this.todoListTotal = response.data.data.total
        }
      });
    },
    changeTodoListSize(val) {
      this.todoListSizeListSize = val;
      this.queryTodoList();
    },
    currentTodoListChange(val) {
      this.todoListpageListPage = val;
      this.queryTodoList();
    },
    async editTodo(row) {
      this.editTodoForm = {};
      this.editTodoVisible = true;
      await this.$axios.get(`schedule/detail?id=${row.master_id}`).then((response) => {
        if (response.data.code === 200) {
          this.editTodoForm = response.data.data;
        }
      })
    },
    downloadAttach(item) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + item.response.url + '&savename=' + item.name;
    },
    confirmTodoSchedule(type) {
      let id = this.editTodoForm.id;
      if (type === 1) {
        // 确认
        this.$confirm('确认吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$axios.post(`/schedule/confirm?id=${id}`).then((response) => {
            if (response.data.code === 200) {
              this.editTodoVisible = false;
              this.queryTodoList();
              this.$notify({
                title: '提示',
                message: '操作成功',
                type: 'success'
              })
            }
          })
        })
      } else {
        this.$prompt('请输入驳回理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          this.$axios.post(`/schedule/reject`, {
            id: id,
            memo: value
          }).then((response) => {
            if (response.data.code === 200) {
              this.editTodoVisible = false;
              this.queryTodoList();
              this.$notify({
                title: '提示',
                message: '操作成功',
                type: 'success'
              })
            }
          })
        })
      }
    },
    completeTodo(row) {
      this.completeTodoVisible = true;
      this.completeTodoForm.id = row.id
      this.completeTodoForm.master_id = row.master_id
    },
    completeUploadSuccess(file, fileList) {
      this.completeTodoForm.fileList = fileList;
    },
    confirmCompleteTodo() {
      this.completeTodoLoading = true;
      this.$axios.post(`/schedule/complete`, this.completeTodoForm).then((response) => {
        this.completeTodoLoading = false;
        if (response.data.code === 200) {
          this.completeTodoVisible = false;
          this.queryTodoList();
          this.$notify({
            title: '提示',
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },


    queryScheduleList(search = false, iv = false) {
      if (iv === false) {
        this.scheduleListLoading = true;
      }
      let scheduleListpage = search === true ? 1 : this.scheduleListPage;
      this.$axios.get(`schedule/list`, {
        params: {
          keywords: this.scheduleListKeywords,
          size: this.scheduleListSize,
          page: scheduleListpage,
          type: 'SCHEDULE'
        }
      }).then((response) => {
        this.scheduleListLoading = false;
        if (response.data.code === 200) {
          this.scheduleList = response.data.data.data
          this.scheduleListTotal = response.data.data.total
        }
      });
    },
    changeScheduleListSize(val) {
      this.scheduleListSize = val;
      this.queryScheduleList();
    },
    currentScheduleListChange(val) {
      this.scheduleListPage = val;
      this.queryScheduleList();
    },
    async createSchedule() {
      this.createScheduleVisible = true;
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
    },
    addStep() {
      this.steps.push([]);
    },
    delStep(key) {
      if (key > 0) {
        this.steps.splice(key, 1)
      } else {
        this.$message({
          type: 'error',
          message: '第一个流程不能删除'
        });
      }
    },
    confirmCreateSchedule() {
      this.$refs.scheduleForm.validate(valid => {
        if (valid) {
          this.createScheduleLoading = true;
          this.$axios.post('/schedule/save',
            this.scheduleForm
          ).then((response) => {
            this.createScheduleLoading = false;
            if (response.data.code === 200) {
              this.queryScheduleList();
              this.createScheduleVisible = false;
            }
          }).catch(function () {
            this.createScheduleLoading = false;
          })
        }
      })
    },
    scheduleUploadSuccess(file, fileList) {
      this.scheduleForm.fileList = fileList;
    },
    async editSchedule(row) {
      this.editScheduleForm = {};
      this.editSteps = [];
      this.editScheduleVisible = true;
      this.editScheduleLoadingText = '正在加载, 请稍候'
      this.editScheduleLoading = true;
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
      await this.$axios.get(`schedule/detail?id=${row.id}`).then((response) => {
        this.editScheduleLoading = false;
        if (response.data.code === 200) {
          this.editScheduleForm = response.data.data;
          this.editSteps = response.data.data.implementers
        }
      })
    },
    addEditStep() {
      this.editSteps.push([]);
    },
    delEditStep(key) {
      if (key > 0) {
        this.editSteps.splice(key, 1)
      } else {
        this.$message({
          type: 'error',
          message: '第一个流程不能删除'
        });
      }
    },
    confirmEditSchedule() {
      this.$refs.editScheduleForm.validate(valid => {
        if (valid) {
          this.editScheduleLoading = true;
          this.$axios.post('/schedule/save',
            this.editScheduleForm
          ).then((response) => {
            this.editScheduleLoading = false;
            if (response.data.code === 200) {
              this.queryScheduleList();
              this.editScheduleVisible = false;
            }
          }).catch(function () {
            this.editScheduleLoading = false;
          })
        }
      })
    },
    toggleHangupSchedule(row) {
      let status = row.status;
      let txt = status === 6 ? '激活' : '挂起'
      this.$confirm('确定' + txt + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/hangup?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    rePubSchedule(row) {
      this.$confirm('确定发布吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/publish?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    closeSchedule(row) {
      this.$confirm('确定关闭吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/close?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    timeline(row, iv = false) {
      let id = iv === false ? row.id : row.master_id;
      this.timelineVisible = true;
      this.timelineLoading = true;
      this.timelineTitle = '流程: ' + row.title + ' 的时间线'
      this.$axios.get(`/schedule/timeline?id=${id}`).then((response) => {
        this.timelineLoading = false;
        if (response.data.code === 200) {
          this.timelineData = response.data.data;
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Schedule/script.js